import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  SendConfirmationMasterComponent
} from './send-confirmation-master/send-confirmation-master.component';

const routes: Routes = [{ path: '', component: SendConfirmationMasterComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SendConfirmationHomeRoutingModule {}
